import PropTypes from "prop-types"
import { createContext } from "react"
import { useMutation } from "react-query"
import {
  removeDiscount,
  setDiscountCourses,
  updateDiscount,
} from "~/actions/discounts"

const DiscountsContext = createContext()
export default DiscountsContext

export const DiscountsContainer = ({ children }) => {
  const updateDiscountMutation = useMutation((data) =>
    updateDiscount(data.data, data.id),
  )
  const setDiscountCoursesMutatation = useMutation((data) =>
    setDiscountCourses(data.courses, data.id),
  )

  const removeDiscountMutation = useMutation((id) => removeDiscount(id))

  return (
    <DiscountsContext.Provider
      value={{
        updateDiscountMutation,
        setDiscountCoursesMutatation,
        removeDiscountMutation,
      }}
    >
      {children}
    </DiscountsContext.Provider>
  )
}

DiscountsContainer.propTypes = {
  children: PropTypes.array,
}
